import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  Pagination,
  Collapse,
} from '@mui/material';
import { 
  formatDate, 
  formatHistoryEntry 
} from '../utils/formatters';

const ITEMS_PER_PAGE = 10;

const ChangeHistory = ({ history, onCreateRule, isOpen }) => {
  const [page, setPage] = React.useState(1);
  const totalPages = Math.ceil(history.length / ITEMS_PER_PAGE);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const displayedHistory = history
    .slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

  return (
    <Collapse in={isOpen} timeout={200}>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Change History
        </Typography>
        <Paper sx={{ p: 2 }}>
          <List>
          {displayedHistory.map((entry, index) => (
              <ListItem
                key={entry.timestamp + index}
                divider
                secondaryAction={
                  entry.type === 'bulk' && (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => onCreateRule(entry)}
                    >
                      Create Rule
                    </Button>
                  )
                }
              >
                <ListItemText
                  primary={formatHistoryEntry(entry)}
                  secondary={formatDate(entry.timestamp)}
                />
              </ListItem>
            ))}
          </List>
          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
        </Paper>
      </Box>
    </Collapse>
  );
};

export default ChangeHistory;
